class TK_Slider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.js_slider');
    this.buttonPrev = this.querySelector('.js_sliderNavigationPrev');
    this.buttonNext = this.querySelector('.js_sliderNavigationNext');
    this.pagination = this.querySelector('.js_sliderPagination');
    this.sliderInstance = null; // Swiper instance placeholder
  }

  initializeSlider(sliderOptions) {
    if (!this.slider) {
      console.error('Slider element not found.');
      return;
    }

    // Ensure existing Swiper instance is destroyed before reinitializing
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
    }

    // Initialize Swiper with provided settings
    this.sliderInstance = new Swiper(this.slider, {
      ...sliderOptions,
      ...(this.buttonPrev && this.buttonNext
        ? {
            navigation: {
              nextEl: this.buttonNext,
              prevEl: this.buttonPrev,
            },
          }
        : {}),
      ...(this.pagination
        ? {
            pagination: {
              el: this.pagination,
              clickable: true,
            },
          }
        : {}),

      on: {
        slideChange: function () {
          // 最後に見えているスライドのindexが18（＝20枚目）以上なら表示切り替え
          const lastVisibleIndex = this.activeIndex + this.params.slidesPerView - 1;
          const viewMoreButton = this.el.querySelector('.js_sliderNavigationNext');
          const viewMoreText = this.el.querySelector('.view-more-text');
          if(viewMoreButton && viewMoreText) {
            console.log('this',this.el);
            console.log('this.slider',this.slider);
            console.log('lastVisibleIndex',lastVisibleIndex);
            if (lastVisibleIndex >= 18) {
              viewMoreButton.style.display = 'none';
              viewMoreText.style.display = 'flex';
            } else {
              viewMoreButton.style.display = 'block';
              viewMoreText.style.display = 'none';
            }
          }
        }
      }
      
    });
  }
}

customElements.define('tk-slider', TK_Slider);